export function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(String(email).toLowerCase());
}

export const validatePhone = (phone, format) => {    
    const firstPart = format.split(' ')[0];
    const dialCodeDots = firstPart.slice(1);
    const dialCodeLength = dialCodeDots.length;

    const phone1 = phone + "";
    var cleanPhone = (phone1.split(".").join("").split('-').join('').split(' ').join('').split('+').join(''));
    // if(cleanPhone.length === 10 ) return true
    // else if(cleanPhone.length === 11 && cleanPhone.slice(0, 1) === '0') return true;
    // else if(cleanPhone.length === 12 && cleanPhone.slice(0, 2) === '91') return true;
    // else return false;

    if(cleanPhone[0]==='0') return false;
    cleanPhone = cleanPhone.slice(dialCodeLength);
    
    if(cleanPhone.length < 4 || (cleanPhone.length+dialCodeLength)>15) return false;
    return true;
}



export const cleanPhone = (phone) => {
    const phone1 = phone + '';
    var cleanPhone = (phone1.split(".").join("").split('-').join('').split(' ').join('').split('+').join(''));
    if(cleanPhone.length === 12) return cleanPhone.slice(2)
    if(cleanPhone.length === 10) return cleanPhone
    if(cleanPhone.length === 11) return cleanPhone.slice(1)
    return cleanPhone
}


// export function extractLocalNumber(phoneNumber, format) {
//     const firstPart = format.split(' ')[0];
//     const dialCodeDots = firstPart.slice(1);
//     const dialCodeLength = dialCodeDots.length;
  
//     return phoneNumber.slice(dialCodeLength);
// }

// export function validatePhoneNumber(phoneNumber, format){
//     console.log(phoneNumber, format);
//     const dotCount = (format.match(/\./g) || []).length;
//     const totalDigits = phoneNumber.length;
//     console.log(dotCount," & ", totalDigits);
//     return totalDigits == dotCount;
// }